/*
 * @Author: zhaoyang
 * @Date: 2024-12-20 16:03:27
 * @Last Modified by: zhaoyang
 * @Last Modified time: 2025-06-12 12:38:30
 */

import qs from 'qs';

import ConfigNew from 'easycash/common/resource/config-new';

export default {
    namespaced: true,

    state: () => ({
        status: {}
    }),

    mutations: {
        SET_CONFIG: (state, data) => {
            state.status = data ?? {};
        }
    },

    actions: {
        async getConfig({commit}, {canGetApi} = {}) {
            let body = {};
            if (canGetApi) {
                const params = {
                    keys: [
                        'app_config.standard_rate_for_web'
                    ]
                };
                const {data: {body: myBody}} = await ConfigNew.generalConfig({
                    hideLoading: true,
                    params,
                    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'}),
                });
                body = myBody;
            } else {
                body = {
                    configs: [
                        {
                            configName: 'app_config.standard_rate_for_web',
                            configValue: '{\n    "rateContentForIdn": "0,1% - 0,3%",\n    "rateContentForEn": "0.1% - 0.3%",\n    "overdueRateContentForIdn": "0,2%-0,3%",\n    "overdueRateContentForEn": "0.2%-0.3%",\n    "ratePictureUrl": "https://indoi18n-web-cdn.easycash.id/cdn/easycash/static/0d218527da59a9e2f1d7.png",\n    "ratePdfUrlForIdn": "https://indoi18n-web-cdn.easycash.id/upload/admin/b986d08b-1dc7-4bd8-b1c2-a13620271491.pdf",\n    "ratePdfUrlForEn": "https://indoi18n-web-cdn.easycash.id/upload/admin/b7d581e1-9d24-408e-8bf9-71257210dda0.pdf"\n}'
                        }
                    ]
                };
            }

            try {
                const config = JSON.parse(body?.configs?.find(item => {
                    return item.configName === 'app_config.standard_rate_for_web';
                }).configValue || '{}');

                commit('SET_CONFIG', config);
            } catch (error) {
                // ignore
            }
        }
    }
};
